export default __webpack_public_path__ + "static/media/DAIF_Extra3_Clean.954c703d.jpg";